import React from "react";
import { Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useStyles } from "./CheckForMobileLayout.styles";
import PropTypes from "prop-types";

import Logo from "./../../assets/images/logo_zoetis@2x.png";
import Logo2 from "./../../assets/images/Combined Shape@2x.png";

const CheckForMobileLayout = (props) => {
  const classes = useStyles(["common"]);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const { t } = useTranslation();

  if (!matches) {
    return props.children;
  } else {
    return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <div className={classes.logoWrapper}>
            <img
              id="zoetislogo"
              src={Logo}
              className={classes.logo}
              alt="zoetis logo"
            ></img>
          </div>
          <div className={classes.description}>
            <div className={classes.descLogoWrapper}>
              <img
                id="vetscanlogo"
                src={Logo2}
                className={classes.logo}
                alt="zoetis logo"
              ></img>
            </div>
            <Typography variant="h6" className={classes.title}>
              {t("common:mobile.title")}
            </Typography>
            <Typography variant="body2" className={classes.message}>
              {t("common:mobile.message")}
            </Typography>
          </div>
          <ul className={classes.list}>
            {/* <li className={classes.listItem}>
              <Link href="#" underline="none" className={classes.secondaryLink}>
                Link 1
              </Link>
            </li>
            <li className={classes.listItem}>
              <Link href="#" underline="none" className={classes.secondaryLink}>
                Link 2
              </Link>
            </li>
            <li className={classes.listItem}>
              <Link href="#" underline="none" className={classes.secondaryLink}>
                Link 3
              </Link>
            </li>
            <li className={classes.listItem}>
              <Link href="#" underline="none" className={classes.secondaryLink}>
                Link 3
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    );
  }
};

CheckForMobileLayout.propTypes = {
  children: PropTypes.any,
};

export { CheckForMobileLayout };
